

import { useEffect, useState } from "react"
import styled from "styled-components"
import { useDispatch, useSelector } from "react-redux"
import Btn from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import InputTextarea from "../../shared/input/new/InputTextarea"
import InputSelect from "../../shared/input/new/InputSelect"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import { updatePortalMembersControl } from "../../../features/admin3/admin3Slice"
import moment from "moment"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 800px;
        max-width: 900px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;

        .content{
            padding: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
            width: 100%;
            height: auto;
            max-height: 600px;
            overflow: auto;

            .input-grp {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .error{
                    font-size: 12px;
                    color: var(--color-main);
                    font-weight: var(--font-weight-lg);
                }
            }

            .const-data-grp{
                display: flex;
                flex-direction: column;
                width: 480px;

                .const-data-item{
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    width: 100%;

                    .key{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        margin-right: 10px;
                        width: 160px;
                    }

                    .value{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        padding: 5px 3px;
                        border-radius: 5px;
                        background-color: ${({theme}) => theme.secondaryBgColor};
                        margin-right: 5px;
                    }

            }


            }


                &::-webkit-scrollbar {
                    width: 0;
                    width: 8px;
                }
                &::-webkit-scrollbar-thumb {
                    background-color: ${({theme})=> theme.scrollThumbColor};
                    border-radius: 10px;
                }
                &::-webkit-scrollbar-track {
                    background-color: transparent;
                }
              
        }

        .btn-container{
            height: 90px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 20px;
            width: 100%;
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
        }

    }
`

const isRivalOptions = [
    {
        id: 1,
        text: "Evet",
        value: true
    },
    {
        id: 2,
        text: "Hayır",
        value: false
    }
]

const loadsPublishedOurGarageOptions = [
    {
        id: 1,
        text: "Yayınlansın",
        value: true
    },
    {
        id: 2,
        text: "Yayınlanmasın",
        value: false
    }
]



const PortalMembersControlUpdateModal = () => {

    const {portalMemberData} = useSelector(state => state.admin3)

    const {modalLocation} = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    const dispatch = useDispatch()
    const location = useLocation()

    const [isSubmit, setIsSubmit] = useState(false)

    const [conversationDetails, setConversationDetails] = useState(portalMemberData.conversationDetails)
    const [whichChannelsReachUs, setWhichChannelsReachUs] = useState(portalMemberData.whichChannelsReachUs)
    const [loadsPublishedOurGarage, setLoadsPublishedOurGarage] = useState(loadsPublishedOurGarageOptions.find(item => item.value === portalMemberData.loadsPublishedOurGarage))
    const [isRival ,setIsRival] = useState(isRivalOptions.find(item => item.value === portalMemberData.isRival))
    const [isRivalDescription, setIsRivalDescription] = useState(portalMemberData.isRivalDescription)
    const [wpNo, setWpNo] = useState(`90${portalMemberData.wpNo}`)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])





    const handeSubmit = () => {

        setIsSubmit(true)

        if( wpNo[2] === "5" && wpNo.length === 12){


            const body = {
                id: portalMemberData.id,
                conversationDetails: conversationDetails,
                whichChannelsReachUs: whichChannelsReachUs,
                loadsPublishedOurGarage: loadsPublishedOurGarage.value,
                isRival: isRival?.value,
                isRivalDescription: !isRival?.value ? "" : isRivalDescription,
                wpNo: wpNo.replace(/^90/, "")
            }

            dispatch(updatePortalMembersControl(body))
        }

    }

    
  return (
    <ModalContainer>
    <div className="modal" onClick={() => dispatch(handleActiveSelect(null))}>
        <PageTopTitle title={"Portal Potansiyel Üye Güncelle"}/>
        <div className="content">
            <InputTextarea data={conversationDetails} setData={(e) => setConversationDetails(e.target.value)} name="conversationDetails" inputWidth={"480px"} labelText={"Konuşma Detayları"}/>
            <InputTextarea data={whichChannelsReachUs} setData={(e) => setWhichChannelsReachUs(e.target.value)} name="whichChannelsReachUs" inputWidth={"480px"} labelText={"Bizlere Hangi Kanallardan Ulaştınız"}/>
            <InputSelect data={loadsPublishedOurGarage.text} setData={setLoadsPublishedOurGarage} name={"loadsPublishedOurGarage"} initialOptions={loadsPublishedOurGarageOptions} inputWidth={"480px"} labelText={"Yükleriniz Kamyon Garajlarımızda Yayınlansın Mı?"}/>
            <InputSelect data={isRival.text} setData={setIsRival} name={"isRival"} initialOptions={isRivalOptions} inputWidth={"480px"} labelText={"Rakip Olabilir Mi?"}/>
            {
                isRival.value &&
                <InputTextarea data={isRivalDescription} setData={(e) => setIsRivalDescription(e.target.value)} name="isRivalDescription" inputWidth={"480px"} labelText={"Neden Rakip Olabilir"}/>
            }
            <div className="input-grp">
                <InputPhoneFormat data={wpNo} setData={setWpNo} labelText="Wp No" inputWidth={"480px"} name={"wpNo"}/>
                {
                    (isSubmit && ((wpNo.length > 2 && wpNo[2] !== "5") || wpNo.length !== 12)) &&
                    <span className="error">Telefon Numarası 5 ile Başlamak ve 10 Haneli Olmak Zorundadır.</span>
                }
            </div>
            <div className="const-data-grp">
                <div className="const-data-item">
                    <span className="key">Kayıt Tarihi: </span>
                    <span className="value">{moment(portalMemberData?.createdDate).format("LLL")}</span>
                </div>
            </div>
            <div className="const-data-grp">
                <div className="const-data-item">
                    <span className="key">Yetkili Adı Soyadı: </span>
                    <span className="value">{portalMemberData?.yetkiliUserName}</span>
                </div>
            </div>
            <div className="const-data-grp">
                <div className="const-data-item">
                    <span className="key">Yetkili Mail: </span>
                    <span className="value">{portalMemberData?.yetkiliMail}</span>
                </div>
            </div>
            <div className="const-data-grp">
                <div className="const-data-item">
                    <span className="key">Yetkili Telefon No: </span>
                    <span className="value">{portalMemberData?.yetkiliPhoneNumber}</span>
                </div>
            </div>
            <div className="const-data-grp">
                <div className="const-data-item">
                    <span className="key">Firma/Koop. Adı: </span>
                    <span className="value">{portalMemberData?.firmaName}</span>
                </div>
            </div>
            <div className="const-data-grp">
                <div className="const-data-item">
                    <span className="key">Vergi No: </span>
                    <span className="value">{portalMemberData?.vergiNo}</span>
                </div>
            </div>
            <div className="const-data-grp">
                <div className="const-data-item">
                    <span className="key">Lojistikçi/Kooperatif: </span>
                    <span className="value">{portalMemberData?.firmaTypeId === 1 ? "Dijital Lojistikçi" : "Kooperatif"}</span>
                </div>
            </div>
            <div className="const-data-grp">
                <div className="const-data-item">
                    <span className="key">Çıkış İlleri: </span>
                    {portalMemberData.routeCities.$values.filter(item => item.type === 0 && item.cityName).map(item => {
                        return <span className="value">{item.cityName}</span>
                    } )}
                </div>
            </div>
            <div className="const-data-grp">
                <div className="const-data-item">
                    <span className="key">Varış İlleri: </span>
                    {portalMemberData.routeCities.$values.filter(item => item.type === 1 && item.cityName).map(item => {
                        return <span className="value">{item.cityName}</span>
                    } )}
                </div>
            </div>
            <div className="const-data-grp">
                <div className="const-data-item">
                    <span className="key">Araç Hacmi(Aylık): </span>
                    <span className="value">{portalMemberData.vehicleVolume}{portalMemberData.vehicleVolume > 0 && " Araç"}</span>
                </div>
            </div>
            <div className="const-data-grp">
                <div className="const-data-item">
                    <span className="key">Kullanıcı Açıklaması: </span>
                    <span className="value">{portalMemberData.userDescription ? portalMemberData.userDescription : "---"}</span>
                </div>
            </div>
        </div>
        <div className="btn-container">
            <Btn width={"225px"} bgColor="#E85446" color="#fff" handleClick={() => handeSubmit()}>Güncelle</Btn>
            <Btn width={"225px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Geri</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default PortalMembersControlUpdateModal